var exports = {
  "Y": "Header__dweGuG",
};

module.exports = exports;
